/* eslint-disable import/extensions */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the settlementBankDetails state domain
 */

const selectBankAccountsDomain = state =>
  state.settlementBankDetails || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by settlementBankDetails
 */

const makeSelectBankAccounts = () =>
  createSelector(
    selectBankAccountsDomain,
    substate => substate,
  );

export default makeSelectBankAccounts;
export { selectBankAccountsDomain };
